// Public entry point of the "@reva/shared/math" subpath.

/**
 * Rounds to a fixed number of decimal places, e.g. `roundToDecimals(1.2345, 2) === 1.23`.
 *
 * Half-way values go towards positive infinity, the way `Math.round` does: `roundToDecimals(0.25, 1)`
 * is `0.3`, `roundToDecimals(-0.25, 1)` is `-0.2`. Binary floating point still applies, so a decimal
 * that only looks like a half-way case can go the other way: `roundToDecimals(1.005, 2)` is `1`.
 */
export function roundToDecimals(value: number, decimals: number): number {
    const factor = 10 ** decimals;
    return Math.round(value * factor) / factor;
}
